<template>
  <div class="mc-widget-call-broadcast_mic-section-wrapper">
    <div class="mc-widget-call-broadcast_mic-section-bars">
      <i class="mc-fa icon-fill_volume-up" />
      <svg
        width="100"
        height="24"
        viewBox="0 0 100 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g :id="`voice-1`">
          <rect
            x="0"
            :y="12 - getBarHeight(0.3)"
            width="4"
            :height="getBarHeight(0.3) * 2"
            rx="2"
            fill="#1C74DA"
          />
          <rect
            x="8"
            :y="12 - getBarHeight(0.5)"
            width="4"
            :height="getBarHeight(0.5) * 2"
            rx="2"
            fill="#1C74DA"
          />
          <rect
            x="16"
            :y="12 - getBarHeight(0.9)"
            width="4"
            :height="getBarHeight(0.9) * 2"
            rx="2"
            fill="#1C74DA"
          />
          <rect
            x="24"
            :y="12 - getBarHeight(0.95)"
            width="4"
            :height="getBarHeight(0.95) * 2"
            rx="2"
            fill="#1C74DA"
          />
          <rect
            x="32"
            :y="12 - getBarHeight(1.0)"
            width="4"
            :height="getBarHeight(1.0) * 2"
            rx="2"
            fill="#1C74DA"
          />
          <rect
            x="40"
            :y="12 - getBarHeight(0.95)"
            width="4"
            :height="getBarHeight(0.95) * 2"
            rx="2"
            fill="#1C74DA"
          />
          <rect
            x="48"
            :y="12 - getBarHeight(0.5)"
            width="4"
            :height="getBarHeight(0.5) * 2"
            rx="2"
            fill="#1C74DA"
          />
          <rect
            x="56"
            :y="12 - getBarHeight(0.3)"
            width="4"
            :height="getBarHeight(0.3) * 2"
            rx="2"
            fill="#1C74DA"
          />
        </g>
        <g :id="`voice-2`">
          <rect
            x="0"
            :y="12 - getBarHeight(0.3)"
            width="4"
            :height="getBarHeight(0.3) * 2"
            rx="2"
            fill="#1C74DA"
          />
          <rect
            x="8"
            :y="12 - getBarHeight(0.4)"
            width="4"
            :height="getBarHeight(0.4) * 2"
            rx="2"
            fill="#1C74DA"
          />
          <rect
            x="16"
            :y="12 - getBarHeight(0.6)"
            width="4"
            :height="getBarHeight(0.6) * 2"
            rx="2"
            fill="#1C74DA"
          />
          <rect
            x="24"
            :y="12 - getBarHeight(0.7)"
            width="4"
            :height="getBarHeight(0.7) * 2"
            rx="2"
            fill="#1C74DA"
          />
          <rect
            x="32"
            :y="12 - getBarHeight(0.5)"
            width="4"
            :height="getBarHeight(0.5) * 2"
            rx="2"
            fill="#1C74DA"
          />
          <rect
            x="40"
            :y="12 - getBarHeight(0.8)"
            width="4"
            :height="getBarHeight(0.8) * 2"
            rx="2"
            fill="#1C74DA"
          />
          <rect
            x="48"
            :y="12 - getBarHeight(0.2)"
            width="4"
            :height="getBarHeight(0.5) * 2"
            rx="2"
            fill="#1C74DA"
          />
          <rect
            x="56"
            :y="12 - getBarHeight(0.1)"
            width="4"
            :height="getBarHeight(0.1) * 2"
            rx="2"
            fill="#1C74DA"
          />
        </g>
      </svg>
    </div>
    <div class="mc-widget-call-broadcast_-mic-animation-time">
      {{ formattedTime }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MicSectionBroadcast',
  props: {
    formattedTime: {
      type: String,
      required: true,
    },
    audioLevel: {
      type: Number,
      required: false,
      default: 0, // 0 to 1
    },
  },
  data() {
    return {}
  },
  computed: {
    /**
     * Smoothed audio level with baseline for more natural animation
     */
    smoothedLevel() {
      // Add minimum baseline so animation is never completely flat
      const baseline = 0.5 // Small baseline when silent
      return baseline + this.audioLevel * (1 - baseline)
    },
  },

  methods: {
    /**
     * Calculate bar height based on audio level and bar multiplier
     * @param {number} multiplier - How much this bar should respond (0-1)
     * @returns {number} Height in pixels
     */
    getBarHeight(multiplier) {
      const minHeight = 1 // Minimum height when silent
      const maxHeight = 8 // Maximum height when speaking loudly
      const height = minHeight + this.smoothedLevel * multiplier * (maxHeight - minHeight)
      return Math.max(minHeight, height)
    },

    /**
     * Calculate bar opacity based on audio level
     * @param {number} multiplier - How much this bar should respond (0-1)
     * @returns {number} Opacity value (0-1)
     */
    getBarOpacity(multiplier) {
      const minOpacity = 0.15 // Very low opacity when silent
      const maxOpacity = 1.0 // Maximum opacity when speaking
      return minOpacity + this.smoothedLevel * multiplier * (maxOpacity - minOpacity)
    },
  },
}
</script>
<style lang="scss">
.mc-widget-call-broadcast_mic-section-wrapper {
  background-color: $cyan-100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 16px;
  border-radius: 4px;
}

.mc-widget-call-broadcast_mic-section-bars {
  display: flex;
  align-items: center;
  column-gap: 8px;
  .icon-fill_volume-up::before {
    color: $mep-primary;
  }
}

#voice-1 {
  animation: 0.25s linear 1s infinite alternate show;
}

#voice-2 {
  animation: 0.25s linear 1s infinite alternate show;
  animation-delay: 0.25s;
}

svg {
  rect {
    transition: all 0.25s ease-out;
  }
}

@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
